// extracted by mini-css-extract-plugin
export default {"card":"EventCard_card__UGWFs","image":"EventCard_image__+rjXp","action":"EventCard_action__OAh-G"};